import { OrganizantionApi } from '../config/api';
import Request from '../../utils/http/request/index';
import util from '../views/absui/ABSProductCompare/util';
import ABSProductCompareDataHelper from '../views/absui/ABSProductCompare/ABSProductCompareDataHelper';

export default {
  namespace: 'absui',
  // 初始状态
  state: {
    navigationMenus: [
      {
        url: '/general',
        icon: 'file',
        name: '通用',
        children: [
          {
            url: '/font',
            icon: 'file',
            name: '字体'
          },
          {
            url: '/color-palette',
            icon: 'file',
            name: '配色板'
          },
          {
            url: '/button',
            icon: 'paper-clip',
            name: '按钮',
            children: []
          },
          {
            url: '/icon',
            icon: 'smile',
            name: '图标',
            children: []
          },
          {
            url: '/link',
            icon: 'file',
            name: '跳转链接'
          },
          {
            url: '/z-index',
            icon: 'file',
            name: '堆叠顺序'
          }
        ]
      },
      {
        url: '/layout',
        icon: 'file',
        name: '布局',
        children: [
          {
            url: '/row-col',
            icon: 'desktop',
            name: '栅格布局',
            children: []
          },
          {
            url: '/flex-container',
            icon: 'desktop',
            name: '右侧固定布局',
            children: []
          },
          {
            url: '/layout',
            icon: 'desktop',
            name: '基础布局',
            children: []
          }
        ]
      },
      {
        url: '/navigation',
        icon: 'file',
        name: '导航',
        children: [
          {
            url: '/steps',
            icon: 'desktop',
            name: '步骤',
            children: []
          },
          {
            url: '/anchor-point',
            icon: 'desktop',
            name: '锚点',
            children: []
          },
          {
            url: '/page-title',
            icon: 'desktop',
            name: '页面头部',
            children: []
          },
          {
            url: '/pagination',
            icon: 'desktop',
            name: '分页',
            children: []
          }
        ]
      },
      {
        url: '/input',
        icon: 'file',
        name: '数据录入',
        children: [
          {
            url: '/filtered-list',
            icon: 'file',
            name: '筛选列表'
          },
          {
            url: '/filter-panel-hor',
            icon: 'file',
            name: '横向筛选列表'
          },
          {
            url: '/switch',
            icon: 'file',
            name: '开关按钮'
          },
          {
            url: '/radio',
            icon: 'desktop',
            name: '单选框',
            children: []
          },
          {
            url: '/checkbox',
            icon: 'desktop',
            name: '多选框',
            children: []
          },
          {
            url: '/input',
            icon: 'file',
            name: '输入框',
            children: []
          },
          {
            url: '/select',
            icon: 'file',
            name: '下拉框',
            children: []
          },
          {
            url: '/search',
            icon: 'desktop',
            name: '搜索框',
            children: []
          },
          {
            url: '/calendar',
            icon: 'file',
            name: '时间选择框',
            children: []
          },
          {
            url: '/double-date-picker',
            icon: 'desktop',
            name: '时间范围选择框',
            children: []
          },
          {
            url: '/flexibleForm',
            icon: 'desktop',
            name: '配置化表单'
          },
          {
            url: '/flexibleModal',
            icon: 'desktop',
            name: '配置化弹窗'
          },
          {
            url: '/form-inspect',
            icon: 'file',
            name: '表单'
          },
          {
            url: '/upload-image',
            icon: 'desktop',
            name: '上传图片',
            children: []
          },
          {
            url: '/upload-file',
            icon: 'desktop',
            name: '上传附件',
            children: []
          },
          {
            url: '/upload-avatar',
            icon: 'desktop',
            name: '上传头像',
            children: []
          },
          {
            url: '/upload-list',
            icon: 'desktop',
            name: '上传列表',
            children: []
          }
        ]
      },
      {
        url: '/display',
        icon: 'file',
        name: '数据展示',
        children: [
          {
            url: '/panel',
            icon: 'desktop',
            name: '面板容器',
            children: []
          },
          {
            url: '/sub-title',
            icon: 'desktop',
            name: '二级标题',
            children: []
          },
          {
            url: '/sub-title-container',
            icon: 'desktop',
            name: '面板内子标题',
            children: []
          },
          {
            url: '/product-page-title',
            icon: 'desktop',
            name: '内容头部',
            children: []
          },
          {
            url: '/header-subtitle',
            icon: 'desktop',
            name: '内容头部副标题',
            children: []
          },
          {
            url: '/tab',
            icon: 'desktop',
            name: 'Tab切换',
            children: []
          },
          {
            url: '/filter-tab',
            icon: 'desktop',
            name: '子Tab切换',
            children: []
          },
          {
            url: '/tag',
            icon: 'file',
            name: '标签',
            children: []
          },
          {
            url: '/progress',
            icon: 'desktop',
            name: '进度条',
            children: []
          },
          {
            url: '/time-line',
            icon: 'desktop',
            name: '时间线',
            children: []
          },

          {
            url: '/registered-process',
            icon: 'desktop',
            name: '注册流程',
            children: []
          },

          {
            url: '/structure',
            icon: 'desktop',
            name: '结构图',
            children: []
          },
          {
            url: '/waterfall-model',
            icon: 'desktop',
            name: '瀑布流模型图',
            children: []
          },
          {
            url: '/expert-chain',
            icon: 'desktop',
            name: '专家链',
            children: []
          },
          {
            url: '/label-value-list',
            icon: 'desktop',
            name: '键值对列表'
          },
          {
            url: '/ant-list',
            icon: 'desktop',
            name: '键值对表格'
          },
          {
            url: '/list',
            icon: 'file',
            name: '基本表格'
          },
          {
            url: '/table-infinity',
            icon: 'desktop',
            name: '滚动加载表格',
            children: []
          },
          {
            url: '/deletable-table',
            icon: 'desktop',
            name: '动态添删列表格',
            children: []
          },
          {
            url: '/security-list',
            icon: 'desktop',
            name: '表格+容器',
            children: []
          },
          {
            url: '/news-list-container',
            icon: 'desktop',
            name: '列表+容器',
            children: []
          },
          {
            url: '/list-detail-container',
            icon: 'desktop',
            name: '表格+详情',
            children: []
          },

          // {
          //   url: '/product-compare',
          //   icon: 'desktop',
          //   name: '产品比较',
          //   children: [],
          // },
          {
            url: '/expert-list',
            icon: 'desktop',
            name: '专家卡片&列表',
            children: []
          },
          // {
          //   url: '/news-list',
          //   icon: 'desktop',
          //   name: '新闻列表',
          //   children: [],
          // },
          {
            url: '/file-header',
            icon: 'desktop',
            name: '文章标题',
            children: []
          },
          {
            url: '/file-list',
            icon: 'desktop',
            name: '文章列表',
            children: []
          },
          {
            url: '/internal-message-card',
            icon: 'desktop',
            name: '站内信消息卡片',
            children: []
          },
          {
            url: '/conference-card',
            icon: 'desktop',
            name: '会议卡片(小)',
            children: []
          },
          {
            url: '/conference-info-list',
            icon: 'desktop',
            name: '会议卡片(大)',
            children: []
          },
          {
            url: '/no-content',
            icon: 'desktop',
            name: '暂无数据',
            children: []
          },
          {
            url: '/errorpage',
            icon: 'desktop',
            name: '错误提示页面',
            children: []
          },
          {
            url: '/file-text',
            icon: 'desktop',
            name: '下载文件',
            children: []
          },

          {
            url: '/emphasize-text',
            icon: 'desktop',
            name: '强调文本',
            children: []
          },
          {
            url: '/data-statistic',
            icon: 'desktop',
            name: '数据统计',
            children: []
          },
          {
            url: '/comment',
            icon: 'desktop',
            name: '注释',
            children: []
          },
          {
            url: '/badge',
            icon: 'desktop',
            name: '动态提醒',
            children: []
          },
          {
            url: '/paragraph',
            icon: 'desktop',
            name: '段落',
            children: []
          },
          {
            url: '/base-list',
            icon: 'desktop',
            name: '工作经历卡片',
            children: []
          },

          {
            url: '/icon-text',
            icon: 'desktop',
            name: '图标+文本',
            children: []
          },
          // {
          //   url: '/icon-text-connect',
          //   icon: 'desktop',
          //   name: '多图标+文字按钮拼接',
          //   children: [],
          // },

          // {
          //   url: '/captcha',
          //   icon: 'desktop',
          //   name: '验证码',
          //   children: [],
          // },
          {
            url: '/countdown',
            icon: 'desktop',
            name: '倒计时',
            children: []
          },
          {
            url: '/simple-image',
            icon: 'desktop',
            name: '图片',
            children: []
          },
          {
            url: '/avatar',
            icon: 'file',
            name: '头像',
            children: []
          },
          {
            url: '/bubble',
            icon: 'file',
            name: '气泡',
            children: []
          },
          {
            url: '/ellipsis',
            icon: 'file',
            name: '省略文本',
            children: []
          },
          {
            url: '/url-list',
            icon: 'desktop',
            name: '彩边卡片',
            children: []
          },
          {
            url: '/other-login',
            icon: 'desktop',
            name: '第三方登录',
            children: []
          },
          // {
          //   url: '/tooltip',
          //   icon: 'desktop',
          //   name: '气泡',
          //   children: [],
          // },
          {
            url: '/danmu',
            icon: 'desktop',
            name: '弹幕',
            children: []
          },

          {
            url: '/api',
            icon: 'desktop',
            name: 'api说明组件',
            children: []
          },
          {
            url: '/internal-message',
            icon: 'desktop',
            name: '站内信组件',
            children: []
          },
          {
            url: '/chart',
            icon: 'desktop',
            name: '图表',
            children: []
          }
        ]
      },
      {
        url: '/feedback',
        icon: 'file',
        name: '反馈',
        children: [
          {
            url: '/modal',
            icon: 'folder-open',
            name: '弹窗',
            children: []
          },
          {
            url: '/loading',
            icon: 'desktop',
            name: '加载中',
            children: []
          },
          {
            url: '/message',
            icon: 'file',
            name: '自动消失提示',
            children: []
          },
          {
            url: '/alert',
            icon: 'file',
            name: '页头提示',
            children: []
          }
        ]
      },
      {
        url: '/other',
        icon: 'file',
        name: '其他',
        children: [
          {
            url: '/download',
            icon: 'desktop',
            name: '下载函数',
            children: []
          },
          {
            url: '/code-structure',
            icon: 'desktop',
            name: '代码目录结构',
            children: []
          }
        ]
      }
    ],
    filterData: [],
    dealDealCompareResult: {},
    dealColumnsData: util.initialDealColumnsData,
    dealContentData: util.initialDealContentData
  },

  effects: {
    *dealCompareResult({ payload }: any, { call, put, select }: any) {
      const response = yield call(Request.post, OrganizantionApi.dealCompareResult, null, payload);
      yield put({
        type: 'updateDealCompareResult',
        payload: response
      });
    }
  },

  reducers: {
    updateDealCompareResult(state: any, { payload }: any) {
      const { columnsData, contentData } = ABSProductCompareDataHelper.formatTableDataSource(payload, state.dealColumnsData, state.dealContentData);
      return {
        ...state,
        dealDealCompareResult: payload,
        dealColumnsData: columnsData,
        dealContentData: contentData
      };
    },
    deleteDealCompareResult(state: any, { payload }: any) {
      const { key } = payload;
      const { dealColumnsData, dealContentData } = state;
      const updatedDealColumnsData = dealColumnsData.filter(column => {
        return column.key !== key;
      });
      const updatedDealContentData = dealContentData.map(row => {
        if (row[key] != null) {
          delete row[key];
        }
        return row;
      });

      return {
        ...state,
        dealColumnsData: updatedDealColumnsData,
        dealContentData: updatedDealContentData
      };
    },
    updateFilterData(state: any, { payload }: any) {
      return {
        ...state,
        filterData: payload
      };
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/models/absui.ts